<div class="container-outter">
  <div class="container">
      <div class="heading-section">
          <div class="heading-title">
            <h1 class="font-darkblue">{{'food_Heading_Title' | translate : globals.getLanguage()}}</h1>
            <p class="font-grey">{{'food_Heading_Paragraph' | translate : globals.getLanguage()}}</p>
              <div class="aside-divider">
                <div class="divider"></div>
                  <p class="font-grey">{{'food_Heading_Paragraph_2' | translate : globals.getLanguage()}}</p>
                <div class="divider"></div>
              </div>
          </div>
      </div>
  </div>
</div>

<div class="container-outter">
<div class="container">
  <div class="container-inner">
    <div class="column col-1">
      <div class="features-content">
        <h3><span class="font-lightblue">01. </span>{{'food_Title_1' | translate : globals.getLanguage()}}</h3>
        <div class="left-divider-sm"></div>
        <ul class="features-list">
          <li>
            <h4>{{'food_Heading_Paragraph_1_1' | translate : globals.getLanguage()}}</h4>
            <p>{{'food_Paragraph_1_1' | translate : globals.getLanguage()}}</p>
          </li>
          <li>
            <h4>{{'food_Heading_Paragraph_1_2' | translate : globals.getLanguage()}}</h4>
            <p>{{'food_Paragraph_1_2' | translate : globals.getLanguage()}}</p>
          </li>
          <li>
            <h4>{{'food_Heading_Paragraph_1_3' | translate : globals.getLanguage()}}</h4>
            <p>{{'food_Paragraph_1_3' | translate : globals.getLanguage()}}</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="column col-2">
      <div class="feature-img features-image-right">
        <img alt="bringfood-img-1" src="../../assets/images/programma-paraggeliolipsias-1.png"/>
      </div>
    </div>
  </div>
</div>
</div>

<div class="container-outter">
  <div class="container">
    <div class="container-inner">
      <div class="column col-2">
        <div class="feature-img features-image-left">
          <img alt="kataskevi-eshop-safe-woocommerce-payments" src="../../assets/images/programma-paraggeliolipsias-2.png"/>
        </div>
      </div>
      <div class="column col-1">
        <div class="features-content">
          <h3><span class="font-lightblue">02. </span>{{'food_Title_2' | translate : globals.getLanguage()}}</h3>
          <div class="left-divider-sm"></div>
          <ul class="features-list">
            <li>
              <h4>{{'food_Heading_Paragraph_2_1' | translate : globals.getLanguage()}}</h4>
              <p>{{'food_Paragraph_2_1' | translate : globals.getLanguage()}}</p>
            </li>
            <li>
              <h4>{{'food_Heading_Paragraph_2_2' | translate : globals.getLanguage()}}</h4>
              <p>{{'food_Paragraph_2_2' | translate : globals.getLanguage()}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  </div>

  <div class="container-outter">
    <div class="container">
      <div class="container-inner">
        <div class="column col-1">
          <div class="features-content">
            <h3><span class="font-lightblue">03. </span>{{'food_Title_3' | translate : globals.getLanguage()}}</h3>
            <div class="left-divider-sm"></div>
            <ul class="features-list">
              <li>
                <h4>{{'food_Heading_Paragraph_3_1' | translate : globals.getLanguage()}}</h4>
                <p>{{'food_Paragraph_3_1' | translate : globals.getLanguage()}}</p>
              </li>
              <li>
                <h4>{{'food_Heading_Paragraph_3_2' | translate : globals.getLanguage()}}</h4>
                <p>{{'food_Paragraph_3_2' | translate : globals.getLanguage()}}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="column col-2">
          <div class="feature-img features-image-right">
            <img alt="kataskevi-istoselidas-eshop-product-upload" src="../../assets/images/programma-paraggeliolipsias-3.png"/>
          </div>
        </div>
      </div>
    </div>
    </div>

    <div class="container-outter">
      <div class="container">
        <div class="container-inner">
          <div class="column col-2">
            <div class="feature-img features-image-left">
              <img alt="app-img" src="../../assets/images/programma-paraggeliolipsias-4.png"/>
            </div>
          </div>
          <div class="column col-1">
            <div class="features-content">
              <h3><span class="font-lightblue">04. </span>{{'food_Title_4' | translate : globals.getLanguage()}}</h3>
              <div class="left-divider-sm"></div>
              <ul class="features-list">
                <li>
                  <h4>{{'food_Heading_Paragraph_4_1' | translate : globals.getLanguage()}}</h4>
                  <p>{{'food_Paragraph_4_1' | translate : globals.getLanguage()}}</p>
                </li>
                <li>
                  <h4>{{'food_Heading_Paragraph_4_2' | translate : globals.getLanguage()}}</h4>
                  <p>{{'food_Paragraph_4_2' | translate : globals.getLanguage()}}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      </div>

      <div class="container-outter">
        <div class="container">
          <div class="container-inner">
            <div class="column col-1">
              <div class="features-content">
                <h3><span class="font-lightblue">05. </span>{{'food_Title_5' | translate : globals.getLanguage()}}</h3>
                <div class="left-divider-sm"></div>
                <ul class="features-list">
                  <li>
                    <h4>{{'food_Heading_Paragraph_5_1' | translate : globals.getLanguage()}}</h4>
                    <p>{{'food_Paragraph_5_1' | translate : globals.getLanguage()}}</p>
                  </li>
                  <li>
                    <h4>{{'food_Heading_Paragraph_5_2' | translate : globals.getLanguage()}}</h4>
                    <p>{{'food_Paragraph_5_2' | translate : globals.getLanguage()}}</p>
                  </li>
                  <li>
                    <h4>{{'food_Heading_Paragraph_5_3' | translate : globals.getLanguage()}}</h4>
                    <p>{{'food_Paragraph_5_3' | translate : globals.getLanguage()}}</p>
                  </li>
                </ul>
              </div>
            </div>
            <div class="column col-2">
              <div class="feature-img features-image-right">
                <img alt="eshop-woocommerce-img-1" src="../../assets/images/programma-paraggeliolipsias-5.png"/>
              </div>
            </div>
          </div>
        </div>
        </div>
    
      <div class="container-outter">
        <div class="container">
          <div class="container-inner">
            <div class="column col-2">
              <div class="feature-img features-image-left">
                <img alt="app-img" src="../../assets/images/programma-paraggeliolipsias-6.png"/>
              </div>
            </div>
            <div class="column col-1">
              <div class="features-content">
                <h3><span class="font-lightblue">06. </span>{{'food_Title_6' | translate : globals.getLanguage()}}</h3>
                <div class="left-divider-sm"></div>
                <ul class="features-list">
                  <li>
                    <h4>{{'food_Heading_Paragraph_6_1' | translate : globals.getLanguage()}}</h4>
                    <p>{{'food_Paragraph_6_1' | translate : globals.getLanguage()}}</p>
                  </li>
                  <li>
                    <h4>{{'food_Heading_Paragraph_6_2' | translate : globals.getLanguage()}}</h4>
                    <p>{{'food_Paragraph_6_2' | translate : globals.getLanguage()}}</p>
                  </li>
                  <li>
                    <h4>{{'food_Heading_Paragraph_6_3' | translate : globals.getLanguage()}}</h4>
                    <p>{{'food_Paragraph_6_3' | translate : globals.getLanguage()}}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        </div>


<div class="container-outter project-section">
  <div class="container">
    <div class="space-bottom">

      <div class="project-heading-section">
        <div class="heading-title">
          <div class="project-title">
            <h2>{{'food_Project_Heading' | translate : globals.getLanguage()}}</h2>
          </div>
        </div>
      </div>

      <div class="column-container">

        <div class="column-box">
          <div class="project-wrapper">
            <a href="https://thegrexican.gr/" rel="nofollow" target="_blank" class="white-box">
                <img class="portfolio-grid-img" src="/assets/images/grexican-logo.jpg" alt="AngeloZafiri.gr">
                <div class="portfolio-box-content">
                  <h4>TheGrexican.gr</h4>
                </div>
            </a>
            <img src="/assets/images/gray-square.png" class="square-topleft"/>
          </div>
        </div>

          <div class="column-box">
            <div class="project-wrapper">
              <a href="https://totemcoffee.gr" rel="nofollow" target="_blank" class="white-box">
                  <img class="portfolio-grid-img" src="/assets/images/totem-logo.jpg" alt="PerfectSleep.gr">
                  <div class="portfolio-box-content">
                    <h4>TotemCoffee.gr</h4>
                  </div>
              </a>
            </div>
          </div>

          <div class="column-box">
            <div class="project-wrapper">
              <a href="https://bookalibar.gr" rel="nofollow" target="_blank" class="white-box">
                  <img class="portfolio-grid-img" src="/assets/images/bookali-logo.jpg" alt="InaHome.gr">
                  <div class="portfolio-box-content">
                    <h4>BookaliBar.gr</h4>
                  </div>
              </a>
            </div>
          </div>

            <div class="column-box">
              <div class="project-wrapper">
                <a href="https://elefantasathens.gr" rel="nofollow" target="_blank" class="white-box">
                    <img class="portfolio-grid-img" src="/assets/images/elephant-logo.jpg" alt="Marinaeshop.gr">
                    <div class="portfolio-box-content">
                      <h4>ElefantasAthens.gr</h4>
                    </div>
                </a>
                <img src="/assets/images/gray-square.png" class="square-botright"/>
              </div>
            </div>

        </div>

        <div class="flex-center">
          <a routerLink="/contactus" routerLinkActive="router-link-active" class="btn project-btn base-transition">{{'food_Project_Button' | translate : globals.getLanguage()}}</a>
          <a href="https://bringfood.gr/" target="_blank" class="btn project-btn base-transition">{{'food_Project_Button_2' | translate : globals.getLanguage()}}</a>
        </div>
    </div>
  </div>
</div>